// PosterManager.tsx
import React from "react";
import { IRunnerCompetitionImage } from "./interface/interface";
import AdminAPI from "../../api/admin";

interface PosterManagerProps {
  posters: IRunnerCompetitionImage[];
  setPosters: (v: IRunnerCompetitionImage[]) => void;
  type: "poster" | "sponsor";
  getData: () => void;
}

const PosterManager: React.FC<PosterManagerProps> = ({
  posters,
  type,
  setPosters,
  getData,
}) => {
  const handleDragStart = (
    e: React.DragEvent<HTMLDivElement>,
    index: number
  ) => {
    e.dataTransfer.setData("text/plain", index.toString());
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  const handleDrop = async (
    e: React.DragEvent<HTMLDivElement>,
    dropIndex: number
  ) => {
    e.preventDefault();
    const runnerCompetitionId = posters[0].runnerCompetitionId;
    const dragIndex = parseInt(e.dataTransfer.getData("text/plain"));
    if (dragIndex === dropIndex) return;

    // 현재 포스터 URL 순서 변경
    const newUrlOrder = [...posters];
    const [removedUrl] = newUrlOrder.splice(dragIndex, 1);
    newUrlOrder.splice(dropIndex, 0, removedUrl);
    setPosters(newUrlOrder);

    const request = newUrlOrder.map((item, index) => {
      return {
        id: item.id,
        displayOrder: index + 1,
      };
    });

    try {
      type === "poster"
        ? await AdminAPI.updateRunnerCompetitionPosterImageSort(
            runnerCompetitionId,
            request
          )
        : await AdminAPI.updateRunnerCompetitionSponsorImageSort(
            runnerCompetitionId,
            request
          );
      await getData();
    } catch (error) {
      console.error("Registration failed:", error);
      alert("삭제에 실패했습니다. ");
    }
  };

  const handleRemove = async (id: number) => {
    try {
      type === "poster"
        ? await AdminAPI.deleteRunnerCompetitionPosterImage(id)
        : await AdminAPI.deleteRunnerCompetitionSponsorImage(id);
      await getData();
      const newPoster = posters.filter((item) => item.id !== id);
      setPosters(newPoster);
    } catch (error) {
      console.error("Registration failed:", error);
      alert("삭제에 실패했습니다. ");
    }
  };

  return (
    <div
      style={{
        width: "95%",
        backgroundColor: "#1E1E1E",
        borderRadius: "10px",
        padding: "20px",
        marginBottom: "30px",
      }}
    >
      <h3
        style={{
          color: "white",
          margin: "0 0 20px 0",
        }}
      >
        {type === "poster" ? "포스터" : "스폰서 이미지"} 관리 (드래그하여 순서
        변경)
      </h3>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        {posters.map((item, index) => (
          <div
            key={index}
            draggable
            onDragStart={(e) => handleDragStart(e, index)}
            onDragOver={handleDragOver}
            onDrop={(e) => handleDrop(e, index)}
            style={{
              backgroundColor: "#2A2A2A",
              position: "relative",
              width: "150px",
              height: "200px",
              borderRadius: "5px",
              cursor: "move",
            }}
          >
            <img
              src={item.imageUrl}
              alt={`포스터 ${index + 1}`}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "5px",
              }}
            />
            <button
              onClick={() => handleRemove(item.id)}
              style={{
                position: "absolute",
                top: "5px",
                right: "5px",
                width: "24px",
                height: "24px",
                backgroundColor: "rgba(221, 44, 0, 0.8)",
                color: "white",
                border: "none",
                borderRadius: "12px",
                fontSize: "12px",
                padding: 0,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              ×
            </button>
            <div
              style={{
                position: "absolute",
                bottom: "5px",
                left: "50%",
                transform: "translateX(-50%)",
                backgroundColor: "rgba(0, 0, 0, 0.7)",
                color: "white",
                padding: "2px 8px",
                borderRadius: "10px",
                fontSize: "12px",
              }}
            >
              {index + 1}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PosterManager;
